import PropTypes from 'prop-types';

function MMDeliActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11291)">
                <path
                    d="M2.92418 18.3162C2.92418 18.3162 2.47156 18.5802 2.54699 19.4779C2.65261 20.7717 3.67854 20.1267 5.35324 20.1757L27.1016 18.2898C27.1016 18.2898 29.4062 18.2559 29.3647 17.3016C29.3232 16.3473 28.1917 16.5472 28.1917 16.5472L2.92418 18.3162Z"
                    fill="#DC6C31"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.87085 20.3037C3.90857 20.7337 4.04058 23.1062 5.19476 23.9435C6.34894 24.7808 9.18159 24.1095 13.6286 23.7247C18.0756 23.34 25.6984 22.9704 26.6867 22.7026C27.1738 22.5793 27.6084 22.3027 27.9262 21.9135C28.2441 21.5243 28.4284 21.0432 28.4519 20.5413C28.4652 19.7581 28.3969 18.9756 28.2482 18.2065L3.87085 20.3037Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.8789 15.9888C2.8789 15.9888 1.83788 19.0478 3.49371 18.9346C7.69553 18.6442 13.4249 17.6484 15.6051 17.8219C17.7852 17.9954 18.1925 20.2849 19.5466 21.1638C21.1082 22.1784 21.9719 20.5226 22.8658 17.3919C23.2619 16.1321 26.0191 17.0864 28.1728 16.5508C29.8814 16.1397 30.1681 14.9591 29.1799 13.9596C28.4255 13.2052 23.9748 12.6432 15.16 13.4353C6.34521 14.2274 2.8789 15.9888 2.8789 15.9888Z"
                    fill="#F1C34B"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.32789 13.922C3.32789 13.922 1.59285 13.922 1.16663 15.227C0.676294 16.7131 2.69422 17.4901 4.56128 17.3279C5.61184 17.2845 6.62996 16.9516 7.50331 16.3661C8.00768 15.9934 8.43435 15.5257 8.75933 14.9894C8.75933 14.9894 9.26852 16.7433 12.252 16.5924C13.8362 16.517 14.9263 15.9361 15.6769 14.3972C16.6274 15.8305 18.0758 16.3284 19.8561 15.9927C21.4138 15.7023 22.5341 13.888 22.5341 13.888C23.4937 14.5781 24.5956 15.0446 25.759 15.2534C27.5129 15.525 30.8623 15.6117 30.4323 13.3486C29.8627 11.8399 27.4676 12.0247 27.4676 12.0247L3.32789 13.922Z"
                    fill="#B0C372"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.32794 13.922C3.29022 12.6961 2.71313 9.35053 5.88901 8.50187C9.0649 7.65321 17.7024 7.26848 20.5652 6.93656C23.428 6.60464 26.0117 7.29111 26.8189 9.12045C27.6261 10.9498 27.4677 12.0248 27.4677 12.0248L3.32794 13.922Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1812 7.82289C10.1812 7.82289 7.85398 9.84836 9.63051 11.7418C9.98507 10.267 10.4905 8.56594 12.8592 7.56641C11.3128 7.77009 10.1812 7.82289 10.1812 7.82289Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.4435 7.45336C14.4435 7.45336 12.1163 9.48261 13.889 11.3761C14.2436 9.90128 14.749 8.23413 17.1177 7.22705L14.4435 7.45336Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.4341 7.13665C18.4341 7.13665 16.2578 9.1244 18.0381 11.0179C18.3926 9.54308 18.7057 7.92873 21.0555 6.9292C19.5091 7.04613 18.4341 7.13665 18.4341 7.13665Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11291">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.600586)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMDeliActive;

MMDeliActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMDeliActive.defaultProps = {
    className: null,
};
